export default __webpack_public_path__ + "static/media/refreshOutlined.e83987c1.svg";